import api from './AxiosInstance';

export class RetenueService {

  getAllRetenue = async (selectedYear, selectedMonth, selectJournal) => {
    try {
      const response = await api.get(`/Retenues/Appel/List?annee=${selectedYear}&mois=${selectedMonth}&codesoc=${selectJournal}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getRetenue = async (selectedYear, selectedMonth, selectJournal) => {
    try {
      const response = await api.get(`/Retenues/Status?ref=${selectJournal}-${selectedYear}-${selectedMonth}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  addRetenue = async (selectedYear, selectedMonth, selectJournal) => {
    try {
      const response = await api.post(`/Retenues/Appel/${selectedYear}/${selectedMonth}/${selectJournal}`, {});
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  importRetenue = async (payload) => {
    try {
      const response = await api.post(`/Retenues/Appel/Import`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  updateRetenue = async (payload) => {
    try {
      const response = await api.post(`/Retenues/Update`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  addValidRetenueCompta = async (payload) => {
    try {
      const response = await api.post(`/Compta/ValidPreviewCompta/RP`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  addPreviewRetenuCompta = async (payload) => {
    try {
      const response = await api.post(`/Compta/PreviewCompta/RP`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getReg = async () => {
    try {
      const response = await api.get(`/Facture/Exercices/Reg`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);

    }
  };

  deleteRetenue = async (listCodeRetenues) => {
    try {
      // Envoyer la liste dans un objet avec la clé attendue par le serveur
      const payload = {
        listCodeRetenues: listCodeRetenues
      };

      const response = await api.post(`/Retenues/Appel/Delete`, payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression des données :', error);
      throw error;
    }
  };

  ///Retenues/Appel/2024/5/002
}


